import { initialState } from './reducer';

export interface IAccessSettingsStore {}

export function getInitialAccessSettingsStore(): IAccessSettingsStore {
  return { ...initialState };
}
